import { queryKeys } from 'hooks/queryKeys'
import { useQuery } from '@tanstack/react-query'
import { useSsrBtcPriceSeed } from 'hooks/ssrQuerySeeds'
import { fetchBtcPrice, type BtcPrice } from 'api/prices'

interface UseBtcPriceOptions {
  /** Override SSR seed (e.g. tests). Defaults to SSR BTC price when present. */
  initialData?: BtcPrice | null
  enabled?: boolean
}

export async function loadBtcPrice(): Promise<BtcPrice | null> {
  try {
    const price = await fetchBtcPrice()
    return price?.USD > 0 ? price : null
  } catch (error) {
    console.log('🚀 ~ error getting btc price:', error)
    return null
  }
}

export function useBtcPrice({ initialData, enabled = true }: UseBtcPriceOptions = {}) {
  const ssrSeed = useSsrBtcPriceSeed()

  return useQuery({
    queryKey: queryKeys.btcPrice(),
    queryFn: loadBtcPrice,
    initialData: initialData ?? ssrSeed,
    enabled,
    staleTime: 24 * 60 * 60 * 1000, // 24 hours
  })
}
